export default __webpack_public_path__ + "static/media/result_breast_bad.3028047c.jpg";